/**
 * Bloqueio de página por papel do usuário
 *
 * Mostra um aviso em vez da página quando o papel do usuário não tem acesso
 * (ex.: Financeiro só para Proprietário e Gerente). O servidor também confere
 * o papel em cada rota; este bloqueio evita a tela cheia de erros 403.
 *
 * @author Equipe VendeAi
 * @since 2.0.0
 */

import { ReactNode } from 'react';
import { ShieldOff } from 'lucide-react';
import { useAuth } from '@hooks/useAuth';

/** Papéis com acesso ao Financeiro (Pendência 034) */
export const FINANCE_ROLES = ['SUPER_ADMIN', 'OWNER', 'MANAGER'];

/** Papéis com acesso ao Status do WhatsApp (#242) */
export const STATUS_ROLES = ['SUPER_ADMIN', 'OWNER', 'MANAGER'];

/** Papéis com acesso à Central de atendimento do WhatsApp (#252) */
export const INBOX_ROLES = ['SUPER_ADMIN', 'OWNER', 'MANAGER', 'ATTENDANT'];

export function RoleGate({ roles, children, message }: { roles: string[]; children: ReactNode; message?: string }) {
  const { user } = useAuth();
  if (user && roles.includes(user.role)) return <>{children}</>;
  return (
    <div
      className="mx-auto mt-10 flex max-w-xl flex-col items-center rounded-2xl border border-gray-200 bg-white p-10 text-center dark:border-gray-700 dark:bg-gray-800"
      role="status"
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200">
        <ShieldOff size={26} />
      </span>
      <h2 className="mt-5 text-xl font-bold text-gray-900 dark:text-white">Acesso restrito</h2>
      <p className="mt-2 text-gray-600 dark:text-gray-400">
        {message ?? 'Esta área é liberada só para o Proprietário e o Gerente do estabelecimento.'}
      </p>
    </div>
  );
}
